import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39d97b18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "expedients py-12 px-16 pe-8 mb-24" }
const _hoisted_2 = {
  key: 0,
  class: "scroll-component-container"
}
const _hoisted_3 = { class: "scroll-component" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-center icon-section" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "icon icon-user-circle",
    title: "En persona",
    "aria-hidden": "true"
  })
], -1))
const _hoisted_5 = { class: "d-flex flex-column align-items-start" }
const _hoisted_6 = { class: "name text-ternary fw-bold mb-8" }
const _hoisted_7 = { class: "name fw-normal" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-center ms-auto ps-8" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "icon icon-expand-right text-primary",
    "aria-hidden": "true"
  })
], -1))
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_loader = _resolveComponent("v-loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.status === 'loaded')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.expedients.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expedients, (expedient, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "item p-12",
                      key: index
                    }, [
                      (_ctx.can('patient.expedient.show'))
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: {name: 'patient.expedient.show', params: {
                expedient:  expedient.id, tabName: 'general'
              }},
                            class: "btn btn-icon d-flex align-items-center item-content btn-sm p-0 justify-content-center",
                            "aria-label": _ctx.$t('Ver expediente')
                          }, {
                            default: _withCtx(() => [
                              _hoisted_4,
                              _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, _toDisplayString(expedient.professional.name) + " " + _toDisplayString(expedient.professional.surname), 1),
                                _createElementVNode("div", _hoisted_7, _toDisplayString(expedient.professional.speciality) + " (" + _toDisplayString(expedient.professional.subspeciality) + ") ", 1)
                              ]),
                              _hoisted_8
                            ]),
                            _: 2
                          }, 1032, ["to", "aria-label"]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t('No tienes ningún paciente')), 1))
        ], 64))
      : (_openBlock(), _createBlock(_component_v_loader, { key: 1 }))
  ]))
}